import React, { createContext, useState } from 'react';

const UploadSuccessContext = createContext(false);

const UploadSuccessProvider = ({ children }) => {
    const [isUploadSuccessful, setIsUploadSuccessful] = useState(false);

    return (
        <UploadSuccessContext.Provider value={{ isUploadSuccessful, setIsUploadSuccessful }}>
            {children}
        </UploadSuccessContext.Provider>
    );
};

export { UploadSuccessContext, UploadSuccessProvider };
